import React, { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { TabSwitcher } from "@ann/web-components";
import {
  SwitcherContainer,
  TabSwitcherContainerLeft
} from "./Switcher.styled";

const Switcher = ({ onTabChange }) => {
  const location = useLocation();
  const { agentId } = useParams();

  // Determine active tab based on current URL using useMemo
  const activeTab = useMemo(() => {
    const pathname = location.pathname;
    if (pathname.includes('/create')) {
      return 'create';
    } else if (pathname.includes('/knowledge')) {
      return 'knowledge';
    } else if (pathname.includes('/instructions')) {
      return 'instructions';
    } else if (pathname.includes('/tools')) {
      return 'tools';
    } else {
      return 'configuration';
    }
  }, [location.pathname]);

  const handleTabChange = (tabId) => {
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  return (
    <SwitcherContainer>
      <TabSwitcherContainerLeft>
        <TabSwitcher
          key={activeTab}
          defaultSelectedId={activeTab}
          size="medium"
          onChange={handleTabChange}
        >
          <TabSwitcher.Button id="create" label="Create" />
          <TabSwitcher.Button id="configuration" label="Configuration" />
          <TabSwitcher.Button id="knowledge" label="Knowledge" />
          <TabSwitcher.Button id="instructions" label="Instructions" />
          <TabSwitcher.Button id="tools" label="Tools" />
        </TabSwitcher>
      </TabSwitcherContainerLeft>
    </SwitcherContainer>
  );
};

export default Switcher;
